import React from 'react';
import GlobalNavbar from '@/components/GlobalNavbar';
import { Server, Activity, Users, Shield } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';

export default function AdminDashboard() {
  const { toast } = useToast();
  
  return (
    <div className="min-h-screen bg-[#F8FAFB]">
      <GlobalNavbar />
      <main className="max-w-7xl mx-auto p-6 space-y-6 mt-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-[#193D6D]">Master Admin</h1>
            <p className="text-gray-500 mt-1">Painel de controle global do sistema.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="p-4 rounded-lg bg-blue-50 text-blue-500"><Server size={24} /></div>
            <div><p className="text-sm font-medium text-gray-500">Organizações</p><p className="text-2xl font-bold text-[#193D6D]">142</p></div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="p-4 rounded-lg bg-green-50 text-green-500"><Users size={24} /></div>
            <div><p className="text-sm font-medium text-gray-500">Usuários Ativos</p><p className="text-2xl font-bold text-[#193D6D]">1,450</p></div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="p-4 rounded-lg bg-purple-50 text-purple-500"><Activity size={24} /></div>
            <div><p className="text-sm font-medium text-gray-500">Casos Totais</p><p className="text-2xl font-bold text-[#193D6D]">8,932</p></div>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
            <div className="p-4 rounded-lg bg-amber-50 text-amber-500"><Shield size={24} /></div>
            <div><p className="text-sm font-medium text-gray-500">System Health</p><p className="text-2xl font-bold text-green-500">100%</p></div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h2 className="text-xl font-bold text-[#193D6D] mb-4">Últimas Organizações Registradas</h2>
          <div className="text-center py-12 text-gray-500 italic">Lista de organizações carregando...</div>
        </div>
      </main>
    </div>
  );
}